import React, { forwardRef } from 'react';
import AsyncSelect from 'react-select/async';

import ChakraReactSelect from '../ChakraReactSelect';

const ReactSelectAsnyc: React.FC<any> = forwardRef((props, ref) => (
  <ChakraReactSelect {...props}>
    {/* @ts-ignore */}
    <AsyncSelect ref={ref} />
  </ChakraReactSelect>
));

export default ReactSelectAsnyc;
